export default Object.freeze([
  'ar-SA',
  'bg-BG',
  'bn-IN',
  'ca-ES',
  'cs-CZ',
  'cy-GB',
  'da-DK',
  'de-DE',
  'el-GR',
  'en-AU',
  'en-CA',
  'en-GB',
  'en-IE',
  'en-IN',
  'en-NL',
  'en-NZ',
  'en-SG',
  'en-US',
  'es-419',
  'es-ES',
  'et-EE',
  'eu-ES',
  'fi-FI',
  'fil-PH',
  'fr-CA',
  'fr-FR',
  'gl-ES',
  'gu-IN',
  'he-IL',
  'hi-IN',
  'hr-HR',
  'hu-HU',
  'id-ID',
  'it-IT',
  'ja-JP',
  'kn-IN',
  'ko-KR',
  'lt-LT',
  'lv-LV',
  'ml-IN',
  'mr-IN',
  'ms-MY',
  'mt-MT',
  'nb-NO',
  'nl-BE',
  'nl-NL',
  'nn-NO',
  'or-IN',
  'pa-Guru-IN',
  'pa-IN',
  'pl-PL',
  'pt-BR',
  'pt-PT',
  'ro-RO',
  'ru-RU',
  'sk-SK',
  'sl-SI',
  'sr-Latn-RS',
  'sv-SE',
  'ta-IN',
  'te-IN',
  'th-TH',
  'tr-TR',
  'vi-VN',
  'zh-Hans',
  'zh-Hans-CN',
  'zh-Hant-HK',
  'zh-Hant-TW',
] as const);
